module.exports = __webpack_public_path__ + "static/media/asgard.18f50944.png";